import countries from 'i18n-iso-countries';

export function setupIsoCountriesLocale() {
  countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
  countries.registerLocale(require('i18n-iso-countries/langs/fr.json'));
  countries.registerLocale(require('i18n-iso-countries/langs/nl.json'));
}
